import NumberDisplay from 'src/javascripts/components/utilities/NumberDisplay';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

export default class CompaniesPositiveStoriesIndex {

  constructor() {}

  render() {

    // Select all locations
    $('.select-all-positive-stories').click(function() {
      $('#positive_stories_table tr .checkbox').prop('checked', this.checked);
    });

    // Number display
    NumberDisplay();
  }
}